export default function ContactUs() {
  return (
    <section className="py-16 overflow-hidden">
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(-50%) translateX(0px) scale(1); }
          25% { transform: translateY(-54%) translateX(4px) scale(1.03); }
          50% { transform: translateY(-48%) translateX(-3px) scale(0.97); }
          75% { transform: translateY(-52%) translateX(5px) scale(1.02); }
        }
        @keyframes shimmer {
          0%, 100% { opacity: 0.6; transform: scale(1) translate(0, 0); }
          33% { opacity: 1; transform: scale(1.1) translate(2px, -2px); }
          66% { opacity: 0.7; transform: scale(0.95) translate(-1px, 1px); }
        }
        @keyframes highlight {
          0%, 100% { opacity: 0.8; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.3); }
        }
        @keyframes innerGlow {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }
        .bubble { animation: float 4s ease-in-out infinite; }
        .bubble-shimmer { animation: shimmer 3s ease-in-out infinite; }
        .bubble-highlight { animation: highlight 2.5s ease-in-out infinite; }
        .bubble-inner { animation: innerGlow 3.5s ease-in-out infinite; }
      `}</style>

      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">

        {/* Giant heading with overlapping images */}
        <div className="relative flex items-center justify-center">

          {/* Giant "Contact Us" text */}
          <h2
            className="text-black leading-none select-none text-center"
            style={{ fontSize: "clamp(40px, 14vw, 200px)" }}
          >
            Contact Us
          </h2>

          {/* Animated transparent glass bubble */}
          <div
            className="bubble absolute left-[45%] sm:left-[42%] top-1/2 z-10 w-16 h-16 sm:w-40 sm:h-40 rounded-full sm:ml-40"
            style={{
              background: "radial-gradient(circle at 35% 35%, rgba(255,255,255,0.95) 0%, rgba(220,230,255,0.4) 40%, rgba(180,200,255,0.15) 70%, rgba(100,150,255,0.05) 100%)",
              boxShadow: "inset -4px -4px 12px rgba(255,255,255,0.6), inset 4px 4px 12px rgba(100,150,255,0.2), 0 8px 32px rgba(100,150,255,0.15), 0 2px 8px rgba(255,255,255,0.8)",
              backdropFilter: "blur(2px)",
              border: "1px solid rgba(255,255,255,0.6)",
            }}
          >
            <div className="bubble-inner absolute inset-2 rounded-full" style={{ background: "radial-gradient(circle at 60% 60%, rgba(150,180,255,0.3) 0%, transparent 70%)" }} />
            <div className="bubble-shimmer absolute top-2 left-2 w-4 h-4 sm:w-10 sm:h-10 rounded-full" style={{ background: "radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 100%)", filter: "blur(3px)" }} />
            <div className="bubble-highlight absolute top-2 left-3 w-1.5 h-1.5 sm:w-3 sm:h-3 rounded-full" style={{ background: "rgba(255,255,255,1)", filter: "blur(1px)" }} />
            <div className="absolute bottom-2 right-2 w-3 h-1.5 rounded-full" style={{ background: "rgba(255,255,255,0.4)", filter: "blur(2px)", transform: "rotate(-20deg)" }} />
          </div>

          {/* Bluekite Consults stamp badge */}
          <div className="absolute right-0 sm:right-[4%] top-0 z-10 sm:mr-60">
            <img
              src="/Group_40.png"
              alt="Bluekite Consults"
              className="w-10 h-10 sm:w-24 sm:h-24 object-contain animate-spin"
              style={{ animationDuration: "10s" }}
            />
          </div>
        </div>

        {/* Bottom two columns of text */}
        <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-6 mt-6 sm:mt-12">
          <p className="text-gray-700 text-sm sm:text-base max-w-xs leading-relaxed">
            Let's create, refine, and grow your brand
            together—reach out to get started
          </p>
          <p className="text-gray-700 text-sm sm:text-base max-w-xs leading-relaxed sm:text-right">
            Ready to elevate your brand? Let's collaborate
            to bring your vision to life.
          </p>
        </div>

      </div>
    </section>
  );
}